export const MOSCOW_ID = '34';

export const isMoscowRegion = (regionCode?: string) => {
  return regionCode?.toString() === MOSCOW_ID;
};
